import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "prodose_token";
// Note: token is in localStorage by design (SPA pattern). XSS is mitigated by
// (1) React's auto-escaping of all rendered content, (2) no inline event handlers
// or eval(), (3) Content-Security-Policy headers at the ingress layer. Moving to
// httpOnly cookies would require CSRF tokens + cross-origin cookie config — a
// separate ticket if/when we add a server-rendered route.
export function getToken() { return localStorage.getItem(TOKEN_KEY); }
export function setToken(t) { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); }

// Attach JWT on every request
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Auth
export const signupAdmin = (d) => api.post("/auth/signup-admin", d).then(r => r.data);
export const login = (d) => api.post("/auth/login", d).then(r => r.data);
export const getMe = () => api.get("/auth/me").then(r => r.data);
export const updateMe = (d) => api.patch("/auth/me", d).then(r => r.data);
export const getInviteInfo = (token) => api.get("/auth/invite-info", { params: { token } }).then(r => r.data);
export const acceptInvite = (d) => api.post("/auth/accept-invite", d).then(r => r.data);

// Team
export const listMembers = () => api.get("/team/members").then(r => r.data);
export const inviteTech = (email) => api.post("/team/invite", { email }).then(r => r.data);
export const revokeInvite = (id) => api.post(`/team/invite/${id}/revoke`).then(r => r.data);
export const resendInvite = (id) => api.post(`/team/invite/${id}/resend`).then(r => r.data);
export const removeMember = (id) => api.delete(`/team/members/${id}`).then(r => r.data);

// Billing
export const createCheckout = () => api.post("/billing/create-checkout-session", { origin_url: window.location.origin }).then(r => r.data);
export const checkoutStatus = (sid) => api.get(`/billing/session-status/${sid}`).then(r => r.data);
export const customerPortal = () => api.post("/billing/customer-portal", { origin_url: window.location.origin }).then(r => r.data);

// Calc
export const calculate = (d) => api.post("/calculate", d).then(r => r.data);
export const saveCalculation = (input, result) => api.post("/calculations", { input, result }).then(r => r.data);
export const listCalculations = () => api.get("/calculations").then(r => r.data);
export const deleteCalculation = (id) => api.delete(`/calculations/${id}`).then(r => r.data);

// Password reset
export const requestPasswordReset = (email) => api.post("/auth/request-password-reset", { email }).then(r => r.data);
export const resetPassword = (token, password) => api.post("/auth/reset-password", { token, password }).then(r => r.data);

// Staff (Poseidon internal)
export const getStaffFlag = () => api.get("/auth/staff-flag").then(r => r.data);
export const listPromoCodes = () => api.get("/admin/promo-codes").then(r => r.data);
export const createPromoCode = (data) => api.post("/admin/promo-codes", data).then(r => r.data);
export const archivePromoCode = (id) => api.post(`/admin/promo-codes/${id}/archive`).then(r => r.data);

// OCR
export const parseWaterAnalysis = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/water-analysis/parse", fd, { headers: { "Content-Type": "multipart/form-data" } }).then(r => r.data);
};
